$(document).ready(function () 
{

    if ($(".comment-btn").length)
    {

        $( ".comment-btn" ).click(function(e)
        {
            e.preventDefault();
            var comment_id = $(this).data('comment-toggle');
            var comment_btn = $(this);
            var comment = '#commentForm-' + comment_id;
            var comment_form_open = false;
            if ($(comment).hasClass('active'))
            {
                comment_form_open = true;   
            }
            $('.comment-form-area').removeClass('active');
            $('.comment-btn').not('.stay-as-comment').html('Reply');
            if(!comment_form_open)
            {
                $(comment).addClass('active');
                if ($(comment_button).hasClass('stay-as-comment'))
                {
                }
                else
                {
                    $(comment_btn).html('Close Reply');
                }
            }

        });

    }
});